module.exports = __webpack_public_path__ + "img/adorable-baby-cute-69096.f8641b1d.jpg";